<template>
<div class="cd">

    <WaitMessage :ob="wdrob" />
    <div v-if="!wdrob.wait && wdrob.message">
        <button class="btn btn--blue" @click.prevent="cancel">Начать заново</button>
    </div>

    <div v-if="!wdrob.wait && !wdrob.message">
        <h2>
            Прошу выплатить вознаграждение в размере {{wdrob.claim.reward.sum}}р. 
        </h2>

        <div class="cd__line">Способ выплаты вознаграждение: <ShowAcc :acc="wdrob.wdr.account" /></div>

        <div class="cd__line">Подтверждаю, что я ознакомлен(а) со всеми необходимыми документами:
            <div class="cd__doc" v-for="doc in wdrob.docs"><a :href="doc.url" target="_blank">{{doc.type_str}}</a></div>
        </div>

        <form @submit.prevent><div v-if="!for_confirm.is" class="cd__buts">

            <button class="btn btn--blue" @click.prevent="confirm(true)">Подтвердить по смс</button>
            <button class="btn" v-if="!disable_dontsend" @click.prevent="confirm(false)">подтвердить без реальной смс (тест)</button>
            <button class="btn btn--blue" @click.prevent="cancel">Отменить</button>

        </div></form>

        <div v-if="for_confirm.is">
            <DoConfirm :wdr_sid="props.wdr_sid" @input="after_confirm" :dontsend="for_confirm.dontsend"  />
        </div>
    </div>
</div>    
</template>

<style lang="scss">
.cd {
    &__line {
        margin: 20px 0;
    }
    &__doc {
        margin: 5px 0 15px 0;
        &::before {
            content: "-";
            margin-right: 10px;
        }
    }
    &__buts {
        margin-top:30px;
    }
}
</style>

<script setup>
import {ref, unref, computed, onMounted, reactive} from 'vue'
import {getInitWithdrwal} from '@/actions.js'
import {isProd as disable_dontsend} from '@/actions.js'
import DoConfirm from '@/payout/DoConfirm.vue'
import { useRouter, useRoute } from 'vue-router/composables'
import WaitMessage from '@/comp/Payout/WaitMessage.vue'
import {ReplaceToMain} from '@/payout/util.js'
import ShowAcc from '@/payout/ShowAcc.vue'

const router = useRouter()
const route = useRoute()

const props = defineProps({
  wdr_sid: String,
  claim_num: String,
})

const for_confirm=reactive({
    is: false,
    dontsend: false,
})
const after_confirm = (ok) => {
//console.log('after_confirm')
    if (ok) {// чтобы в истории не оставалось ссылка на эту уже не актуальную страничку
        ReplaceToMain( {route, router} ) // так как можно нажать бэк то проверяем актуальный path
    } else {
        for_confirm.is = false
        for_confirm.dontsend = false
    }
}

const cancel = () => {
    router.push({name: 'Start'})
}

const confirm = real => {
    for_confirm.dontsend = real ? false : true
    for_confirm.is = true
}

const wdrob = reactive({
  wdr : null,
  docs: null,
  claim: null,
  wait: true,
  message: '',
})

const load = () => {
    wdrob.wdr = null
    wdrob.docs = null
    wdrob.claim =null
    wdrob.wait = true
    wdrob.message = ''
    const {wdr_sid} = props

    getInitWithdrwal({wdr_sid}).then( ({wdr, docs, claim}) => {
      wdrob.wdr = wdr
      wdrob.docs = docs
      wdrob.claim = claim
      wdrob.wait = false
    }, message => {
      wdrob.wait = false
      wdrob.message = `По заявке ${props.claim_num} запустить процесс выплаты не удалось: ${message}`
    } )
}

onMounted(load)

</script>
